import { createAuth0Client } from '@auth0/auth0-spa-js';

import { findEnvAttr } from '../process';

export default createAuth0Client({
	domain: findEnvAttr('REACT_APP_AUTH_0_ENDPOINT'),
	clientId: findEnvAttr('REACT_APP_AUTH_0_CLIENT_ID'),
	authorizationParams: {
		audience: findEnvAttr('REACT_APP_AUTH_O_AUDIENCE'),
		redirect_uri: window.location.origin
	},
	cacheLocation: 'localstorage',
	useRefreshTokens: true
});
